import { unFormatUnknownUnit } from "@/common/utils/unFormatters";
import { isBefore, parse, startOfDay } from "date-fns";
import z from "zod";

export const auctionEntryProposalSchema = z.object({
  auction_entry_id: z.string(),
  directive_proposal_content_attributes: z.object({
    start_at_date: z
      .string({ message: 'Campo obrigatório' })
      .refine((value) => {
        const parsed = parse(value, 'dd/MM/yyyy', new Date());

        return !isBefore(startOfDay(parsed), startOfDay(new Date()));
      }, { message: 'A data não pode ser anterior ao dia de hoje' }),
    start_at_time: z.string({ message: 'Campo obrigatório' }),
    deadline_to_complete_in_days: z
      .string({ message: 'Campo obrigatório' })
      .refine((value) => {
        return unFormatUnknownUnit(value);
      }, { message: 'Campo obrigatório' }),
  }),
});

export type AuctionEntryProposalValidationSchema = z.infer<typeof auctionEntryProposalSchema>;
